module.exports = __webpack_public_path__ + "img/gb5784.prt.6a0955de.jpg";